export default {
    title: 'Log in',
    login: 'Log in',
    passwordHint: 'Student ID + Date of birth eg. T1234DDYYYY using the year AD',
    schoolLabel: 'School',
    schoolPlaceholder: '- Select -',
    usernameLabel: 'First name & Last name (Student)',
    usernamePlaceholder: 'Firstname Lastname',
    usernameRequired: 'Enter ID card / passport',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Enter password',
    passwordRequired: 'Enter password'
}
